import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M19.334 11.088c-5.173 1.746-6.588 3.16-8.334 8.334-1.745-5.173-3.16-6.588-8.333-8.334C7.84 9.342 9.255 7.928 11 2.755c1.746 5.173 3.16 6.587 8.334 8.333z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" /></svg>;